"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = profile;

/**
 * Executes the callback and returns its result while logging the execution time to the console.
 * @param {String} label A string to preface the console.log
 * @param {Function} cb A function to execute
 * @return {Object} The result of the function
 */
function profile(label, cb) {
  if (process.env.NODE_ENV === 'production') {
    return cb();
  } else {
    var start = new Date().getTime();
    var result = cb();
    var end = new Date().getTime();
    console.log(label, "".concat(end - start, " ms"));
    return result;
  }
}

global.rsf_profile = profile;
//# sourceMappingURL=profile.js.map